import { render, staticRenderFns } from "./centerData.vue?vue&type=template&id=6f85bf94&scoped=true&"
import script from "./centerData.vue?vue&type=script&lang=js&"
export * from "./centerData.vue?vue&type=script&lang=js&"
import style0 from "./centerData.vue?vue&type=style&index=0&id=6f85bf94&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f85bf94",
  null
  
)

export default component.exports